import { TerrainItemEntity } from '@src/features/order/pages/upsert-mission-page/entities';

export const interpolateAltitude = (
  distance: number,
  points: TerrainItemEntity[],
): number => {
  if (points.length === 0) return 0;
  if (distance <= points[0].distance) return Number(points[0].altitude);
  if (distance >= points[points.length - 1].distance) return Number(points[points.length - 1].altitude);

  for (let i = 0; i < points.length - 1; i++) {
    if (points[i].distance <= distance && points[i + 1].distance >= distance) {
      const totalDist = points[i + 1].distance - points[i].distance;
      if (totalDist === 0) return Number(points[i].altitude);
      const ratio = (distance - points[i].distance) / totalDist;
      return Number(points[i].altitude) + (Number(points[i + 1].altitude) - Number(points[i].altitude)) * ratio;
    }
  }

  return Number(points[points.length - 1].altitude);
};
